import styled from "styled-components";

export const DocumentsChecklistWrapper = styled.div`
  .checklist-container {
    margin-bottom: 32px
  }
`;